import React, { Component } from 'react';

class Expansion extends Component {
    state = {
        isOpen: false
    };

    toggle = () => this.setState({ isOpen: !this.state.isOpen });

    componentDidMount() {
        const { isOpen } = this.props;

        if (typeof isOpen !== 'undefined') {
            this.setState({ isOpen });
        }
    };

    render() {
        const { isOpen } = this.state;
        const { children, label } = this.props;

        return (
            <div className={`expansion ${isOpen ? 'is-expansion-open' : ''}`}>
                <div className="expansion__head" onClick={this.toggle}>
                    <div className="expansion__label">{label}</div>
                    <div className="expansion__icon"></div>
                </div>
                <div className="expansion__content">
                    { children }
                </div>
            </div>
        );
    }
}

export { Expansion };